module.exports = __webpack_public_path__ + "img/pip4.c189797c.jpg";